import React from 'react';
import styles from '../../styles';
import { Input } from 'components/shared';
import * as FormikFields from 'formik-material-ui';
import { Divider, Tooltip } from '@material-ui/core';
import { ServiceName, Values } from '../types';
import {
    getServiceName,
    renderMultipleClassNames,
    getImageByService,
} from 'helpers/helperFunctions';
import { useAppSelector } from 'index';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import i18n from 'i18n-js';

type ServiceTopViewProps = {
    values: Values;
    onChangeActive: (service: ServiceName, isActive: boolean) => void;
};

export default function ServiceTopView(props: ServiceTopViewProps) {
    const restaurant = useAppSelector((state) => state.restaurantDetails.restaurantInformation);
    const classes = styles();

    function renderCheckBox(name: ServiceName, disabled: boolean = false) {
        return (
            <Input
                component={FormikFields.Switch}
                checked={props.values[name].isActive}
                disabled={disabled}
                onChange={() => props.onChangeActive(name, !props.values[name].isActive)}
                name={name}
                color="primary"
            />
        );
    }

    const renderServiceBlock = (serviceName: ServiceName, style?: any) => {
        return (
            <div className={renderMultipleClassNames([classes.seviceTopColumnContainer, style])} style={{ paddingTop: 16}}>
                {serviceName === 'takeOut' && (
                    <Tooltip title={i18n.t('restaurant.takeOutHoursHint')} arrow placement="top">
                        <InfoOutlinedIcon className={classes.takeoutInfoIcon} color="primary" fontSize="small"/>
                    </Tooltip>
                )}
                {getImageByService(serviceName, classes, props.values[serviceName].isActive, props.values)}
                <span className={classes.serviceNameContainer}>{getServiceName(serviceName)}</span>
                {renderCheckBox(serviceName, serviceName === 'takeOut' && !props.values.dineIn.isActive)}
                <Divider className={classes.divider70px} />
            </div>
        );
    };

    return (
        <div className={classes.servicesTopContainer}>
            <div className={classes.serviceTopLeft}>
                MO{/* as dayName in ServiceDayRow (hiden here)*/}
            </div>
            {!restaurant.coolBoxData.isCoolBox && renderServiceBlock('homeDelivery')}
            {renderServiceBlock('takeAway')}
            {!restaurant.coolBoxData.isCoolBox && renderServiceBlock('dineIn')}
            {!restaurant.coolBoxData.isCoolBox && renderServiceBlock('takeOut')}
        </div>
    );
}
